module.exports = __webpack_public_path__ + "static/media/calendar_today_header.9fed4ca6.svg";